export default "__VITE_ASSET__C7Z9$txZ__"